import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css'; // Make sure you have a CSS file for styling

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-left">
          <p>&copy; 2025 Victorise. All rights reserved.</p>
          <nav className="footer-navigation">
            <Link to="/tos" className="footer-link">Terms of Service</Link> | 
            <Link to="/privacypolicy" className="footer-link"> Privacy Policy</Link>
          </nav>
        </div>
        <div className="footer-right">
          <a
            href="https://buymeacoffee.com/victorise"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '0.75rem 1.5rem',
              backgroundColor: 'transparent',
              border: '2px solid #13A1A8',
              borderRadius: '8px',
              color: '#FFFFFF',
              textDecoration: 'none',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              fontFamily: 'inherit',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#13A1A8';
              e.currentTarget.style.color = '#FFFFFF';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#FFFFFF';
            }}
          >
            ☕ Buy me a coffee
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;